//import { IonCol, IonGrid, IonRouterLink, IonRow } from '@ionic/react';
import React from 'react';
//import { PageLinks } from '../../common/Constants';
const HomeProductCategories: React.FC = () => {
    return (
        <div>
            <section className="categorie-section ">
                {/* <div className="sec-heading rotate-rl">Product <span> Categories</span></div> */}
                <div className="container-fluid bg-light py-2">
                    {/* <IonGrid>
                        <IonRow>
                            <IonCol size="12" size-md="12" size-lg="12">
                                <h2 className="sec-title">Product Categories</h2>
                                <p className="sec-desc">
                                    Lorem Ipsum is simply dummy text
                                </p>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                    <IonGrid>
                        <IonRow>
                            <IonCol size="12" size-md="4" size-lg="3">
                                <div className="single-cate-bg">
                                    <IonRouterLink routerLink={PageLinks.PRODUCT_DETAILS} className="single-cate">
                                        <img src="assets/images/home/home_category_1.jpg" />
                                    </IonRouterLink>
                                    <p>Mosquito Nets For Beds</p>
                                </div>
                            </IonCol>
                            <IonCol size="12" size-md="4" size-lg="3">
                                <div className="single-cate-bg">
                                    <IonRouterLink routerLink={PageLinks.PRODUCT_DETAILS} className="single-cate">
                                        <img src="assets/images/home/home_category_2.jpg" />
                                    </IonRouterLink>
                                    <p>Outdoor Mosquito Nets</p>
                                </div>
                            </IonCol>
                            <IonCol size="12" size-md="4" size-lg="3">
                                <div className="single-cate-bg">
                                    <IonRouterLink routerLink={PageLinks.PRODUCT_DETAILS} className="single-cate">
                                        <img src="assets/images/home/home_category_3.jpg" />
                                    </IonRouterLink>
                                    <p>Mosquito Nets For Pets</p>
                                </div>
                            </IonCol>
                            <IonCol size="12" size-md="4" size-lg="3">
                                <div className="single-cate-bg">
                                    <IonRouterLink routerLink={PageLinks.PRODUCT_DETAILS} className="single-cate">
                                        <img src="assets/images/home/home_category_4.jpg" />
                                    </IonRouterLink>
                                    <p>Bags and Pouches</p>
                                </div>
                            </IonCol>
                        </IonRow>
                    </IonGrid> */}


                    <div className="row col-lg-12 bg-light p-3 py-2 justify-content-center align-items-top">
                        <div className="text-center mb-3 mt-2 col-lg-12">
                            {/* <h4 className="sec-title fw-bold ">Features</h4> */}
                            <h2 className="sec-title text-center">Our Features</h2>
                        </div>
                        {/* Left Section */}
                        <div className="col-lg-4 rounded">
                            {/* <div className="col-lg-10">
                                <h4 className="fw-bold text-center">Why Venetz Mosquito Nets?</h4>
                                <p className="sec-desc">
                                    The best venetz mosquito nets Mosquitoes are something beyond irritation — they can spread destructive sicknesses like West Nile infection and Heartworm to your pets...
                                </p>
                            </div>
                            <div className="col-lg-10 mt-4">
                                <h4 className="fw-bold text-center">Durable Mosquito nets which can last up to 2 years and frame lifetime</h4>
                                <p className="sec-desc">
                                    Venetz Mosquito Net for beds with ready-to-install frames can be assembled easily...
                                </p>
                            </div> */}
                            <div className="row justify-content-center gap-4">
                                <div>
                                    <h4 className="fw-bold text-info text-start">Why Use Venetz Bed Nets?</h4>
                                    <ul className="list-unstyled pl-3 fs-4">
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Ensures a Peaceful Sleep</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Boosts Immunity with Undisturbed Rest</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Maintains Ideal Temperature Inside</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Costs only 60 paise/day for Family Health</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Enhances Kids Rational Thinking</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Essential for Elderly and Kids Health</li>
                                    </ul>

                                </div>
                            </div>
                        </div>

                        {/* Feature Section */}
                        <div className="col-lg-4 rounded">
                            <div className="row justify-content-center gap-4">
                                {/* Left Column */}
                                <div className="">
                                    <h4 className="fw-bold text-info text-start">Features of Venetz Mosquito Net:</h4>
                                    <ul className="list-unstyled pl-3" style={{ listStyleType: 'circle' }}>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Highly Durable (Net lasts up to - 2 Years & Frame - Lifetime)</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Flame Resistant</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Easy Machine Washable</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Recyclable Material</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Smooth Finish</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Available in 6 Colors</li>
                                    </ul>


                                </div>

                                {/* Right Column */}

                            </div>
                        </div>
                        <div className="col-lg-4 rounded">
                            <div className="justify-content-center gap-4">
                                <div>
                                    <h4 className="fw-bold text-info mt-3 text-start">Technical Details:</h4>
                                    <ul className="list-unstyled pl-3">
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Made from Polyethylene</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Non-Tearable</li>
                                        <li className='sec-desc'><span className='text-success' style={{ fontSize: '20px' }}>&#128973;</span> Long-lasting</li>
                                    </ul>

                                    <p className="fw-bold  mt-3 fs-5">
                                        <strong>BEST MOSQUITO NET TO PREVENT MOSQUITO BITES</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Side - Features Section */}
                    {/* <div className="col-12 bg-secondary-light p-4 rounded">
                        <div className="text-center mb-3">
                            <h4 className="fw-bold">Features</h4>
                        </div>
                        <div className="row justify-content-center">
                         
                            <div className="col-md-5">
                                <h5 className="fw-bold text-start">Features of Venetz Mosquito Net:</h5>
                                <ul className="list-unstyled ps-3">
                                    <li>- Highly Durable (Lasts up to 10 years)</li>
                                    <li>- Flame Resistant</li>
                                    <li>- Easy Machine Washable</li>
                                    <li>- Recyclable Material</li>
                                    <li>- Smooth Finish</li>
                                    <li>- Available in 6 Colors</li>
                                </ul>

                                <h5 className="fw-bold text-start mt-3">Technical Details:</h5>
                                <ul className="list-unstyled ps-3">
                                    <li>- Made from Polyethylene</li>
                                    <li>- Non-Tearable</li>
                                    <li>- Long-lasting (10 Years)</li>
                                </ul>
                            </div>

                            <div className="col-md-5">
                                <h5 className="fw-bold text-start">Why Use Venetz Bed Nets?</h5>
                                <ul className="list-unstyled ps-3">
                                    <li>- Ensures a Peaceful Sleep</li>
                                    <li>- Boosts Immunity with Undisturbed Rest</li>
                                    <li>- Maintains Ideal Temperature Inside</li>
                                    <li>- Costs only 60 paise/day for Family Health</li>
                                    <li>- Enhances Kids Rational Thinking</li>
                                    <li>- Essential for Elderly and Kids Health</li>
                                </ul>

                                <p className="fw-bold text-center text-primary mt-3 fs-5">
                                    BEST MOSQUITO NET TO PREVENT MOSQUITO BITES
                                </p>
                            </div>
                        </div>
                    </div> */}

                </div>
                {/* <div className="cate-shage"><img src="assets/images/home/shape1.png" alt="" /></div> */}

                <div className="container-fluid  mt-3">
                    {/* <div className="row justify-content-around align-item-center">
                        <div className="border rounded text-center col-lg-3 col-md-6 bg-light">
                            <div className="single-service m-2 text-center pt-3">
                                <img src="assets/images/home/truck2.png" alt="" className='mt-4' />
                                <h4>Free Shipping</h4>
                                <p>Free Shipping of Mosquito nets with ready to use frame on orders above Rs.500</p>
                            </div>
                        </div>
                        <div className="border col-lg-3 col-md-6 bg-light">
                            <div className="single-service m-2 text-center pt-3">
                                <img src="assets/images/home/undo2.png" alt="" className='mt-4' />
                                <h4>Hassle Free Installations</h4>
                                <p>The protective mosquito net Comes with both Mosquito Net and the ready to install Mosquito net Frame, which can be installed to any bed within 5 minutes of time.</p>
                            </div>
                        </div>
                        <div className="border col-lg-3 col-md-6 bg-light">
                            <div className="single-service m-2 text-center pt-3">
                                <img src="assets/images/home/headphone2.png" alt="" className='mt-4' />
                                <h4>Customize Product</h4>
                                <p>We are ready to cater your custom sized protective nets for Bed rooms, Outdoor gardens and for Pets. Click here if you are looking for Custom sized mosquito nets</p>
                            </div>
                        </div>
                    </div> */}
                    <div className="row justify-content-around align-items-center text-center">
                        <div className="border rounded col-lg-3 col-md-6 bg-light d-flex flex-column align-items-center p-3">
                            <img src="assets/images/home/truck2.png" alt="" className="mt-4" />
                            <h3>Free Shipping</h3>
                            <p className='sec-desc'>Free Shipping of Mosquito nets with ready to use frame on orders above Rs.500</p>
                        </div>
                        <div className="border rounded col-lg-3 col-md-6 bg-light d-flex flex-column align-items-center p-3">
                            <img src="assets/images/home/undo2.png" alt="" className="mt-4" />
                            <h3>Hassle Free Installations</h3>
                            <p className='sec-desc'>The protective mosquito net comes with both the Mosquito Net and the ready-to-install Mosquito Net Frame, which can be installed on any bed within 5 minutes.</p>
                        </div>
                        <div className="border rounded col-lg-3 col-md-6 bg-light d-flex flex-column align-items-center p-3">
                            <img src="assets/images/home/headphone2.png" alt="" className="mt-4" />
                            <h3>Customize Product</h3>
                            <p className='sec-desc'>We are ready to cater to your custom-sized protective nets for bedrooms, outdoor gardens, and pets. Click here if you are looking for custom-sized mosquito nets.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className="service-section"> */}

            {/* </section> */}
            <section className="container-fluid mb-3 bg-gray">
                <div className="col-lg-12 col-md-12 p-0 text-center">
                    <img src="assets/images/home/bg_text.jpg" />
                </div>
            </section>
        </div>
    );
};
export default HomeProductCategories;